import { EDevFeature } from '../types';
import { getDevFeaturesFromStorage } from './getDevFeaturesFromStorage';

export const isDevFeatureEnabled = (feature: EDevFeature): boolean => {
  const config = getDevFeaturesFromStorage();
  return !!config[feature];
};
